import { useContext } from "react";
import NavBarContext from "../context/NavBarProvider";

const useNavBar = () => {
    return useContext(NavBarContext);
}

export default useNavBar;